/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import H1 from '../../atoms/Label/Headers/H1';
import Paragraph from '../../atoms/Label/Paragraph/Clear';
import { Wrapper } from './style';

const GeneralTXT = ({ txtHtml, title }) => (
	<Wrapper className="general-txt-section">
		<div className="top-section">
			<div className="container">
				<div className="row top-section__wrapper">
					<div className="col-md-12 mb-5">
						<H1 className="h1Default top-section__text--title">{title}</H1>
					</div>
				</div>
			</div>
		</div>
		<div className="content-wrapper">
			<div className="container">
				<div className="row banner-home__wrapper">
					<div className="col-md-9 mt-5 mb-5 content">
						<Paragraph>
							<div
								dangerouslySetInnerHTML={{
									__html: txtHtml,
								}}
							/>
						</Paragraph>
					</div>
				</div>
			</div>
		</div>
	</Wrapper>
);

GeneralTXT.propTypes = {
	txtHtml: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
};

export default GeneralTXT;
